export default __webpack_public_path__ + "static/media/2020.776ee2de.png";